function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2,
  filter: "url(#map-marker-small_svg__filter0_f_41029_4735)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52 48.704c0 3.598-16 8.096-20 8.096s-20-4.498-20-8.096c0-2.483 8.954-4.497 20-4.497s20 2.014 20 4.497z",
  fill: "#000"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-figma-bg-blur-radius": 35.556
}, /*#__PURE__*/React.createElement("path", {
  d: "M52 20.286C52 36.514 36 56.8 32 56.8S12 36.514 12 20.286C12 9.082 20.954 0 32 0s20 9.082 20 20.286z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 .37c10.836 0 19.63 8.912 19.63 19.916 0 8.01-3.957 17.067-8.443 24.145-2.239 3.533-4.6 6.556-6.642 8.69-1.022 1.068-1.958 1.906-2.753 2.475a6.488 6.488 0 01-1.06.635c-.312.14-.555.199-.732.199-.177 0-.42-.058-.731-.2a6.488 6.488 0 01-1.061-.634c-.795-.569-1.731-1.407-2.753-2.475-2.042-2.135-4.403-5.157-6.642-8.69-4.486-7.078-8.443-16.134-8.443-24.145C12.37 9.282 21.164.37 32 .37z",
  stroke: "url(#map-marker-small_svg__paint0_linear_41029_4735)",
  strokeOpacity: 0.5,
  strokeWidth: 0.741
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 17.185,
  y: 5.098,
  width: 29.63,
  height: 29.125,
  rx: 14.563,
  fill: "#4951EF"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 16.815,
  y: 4.727,
  width: 30.37,
  height: 29.866,
  rx: 14.933,
  stroke: "url(#map-marker-small_svg__paint1_linear_41029_4735)",
  strokeOpacity: 0.5,
  strokeWidth: 0.741
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "map-marker-small_svg__paint0_linear_41029_4735",
  x1: 32,
  y1: 0,
  x2: 32,
  y2: 56.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.471,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A1A1A1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "map-marker-small_svg__paint1_linear_41029_4735",
  x1: 32,
  y1: 5.098,
  x2: 32,
  y2: 34.223,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A1A1A1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.529,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "map-marker-small_svg__bgblur_0_41029_4735_clip_path",
  transform: "translate(23.556 35.556)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52 20.286C52 36.514 36 56.8 32 56.8S12 36.514 12 20.286C12 9.082 20.954 0 32 0s20 9.082 20 20.286z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "map-marker-small_svg__filter0_f_41029_4735",
  x: 0.148,
  y: 32.355,
  width: 63.704,
  height: 36.297,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.926,
  result: "effect1_foregroundBlur_41029_4735"
})));

function SvgMapMarkerSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 69,
    viewBox: "0 0 64 69",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default "data:image/svg+xml;base64,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";
export { SvgMapMarkerSmall as ReactComponent };